import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function CarbonCopyIcon({
  className,
  height,
  stroke = IconColors.DarkGrey,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 24}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <path
        d="M17.625,23.25H4.125a1.5,1.5,0,0,1-1.5-1.5V5.625"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5px"
      ></path>
      <path
        d="M21.375,18.159A1.8,1.8,0,0,1,19.625,20H7.375a1.8,1.8,0,0,1-1.75-1.841V2.591A1.8,1.8,0,0,1,7.375.75h8.9a1.711,1.711,0,0,1,1.238.539l3.349,3.524a1.888,1.888,0,0,1,.513,1.3Z"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5px"
      ></path>
    </SimpleIcon>
  );
}
